import React from 'react';
import { BookOpen, Compass, Share2 } from 'lucide-react';
import Hero from '../components/home/Hero';
import FeatureCard from '../components/home/FeatureCard';
import ExploreCard from '../components/home/ExploreCard';
import StoryGenerator from '../components/home/StoryGenerator';
import { DarkGridHero } from '../components/hero/DarkGridHero';

const Home = () => {

  return (
    <DarkGridHero />
  );
};

export default Home;